<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import { ProductQuery } from "@apps/iloom_customization/modules/products/queries/ProductQuery";
    import { ReviewsQuery } from "@apps/iloom_customization/reviews/queries/ReviewsQuery";
    import { WishlistProductStatusesQuery } from "@apps/wishlist/queries/WishlistProductStatusesQuery";
    import { WishlistsService } from "@apps/wishlist/services/WishlistsService";
    import { createEventDispatcher } from "svelte";

    import ReviewsItem from "./ReviewsItem.svelte";
    import ReviewsItemSkeleton from "./ReviewsItemSkeleton.svelte";

    export let productQuery: ProductQuery;
    export let reviewsQuery: ReviewsQuery;
    export let wishlistsService: WishlistsService;
    export let wishlistProductStatusesQuery: WishlistProductStatusesQuery;

    const dispatch = createEventDispatcher();

    const reviews$ = reviewsQuery.reviews$;
    const status$ = reviewsQuery.status$;

    const reviewSkeletonItems = new Array(4)
        .fill(null)
        .map((_, idx) => idx + 1);

    const handleOpenReviewModal = (
        event: CustomEvent<{ reviewId: number }>
    ) => {
        dispatch("openModal", {
            reviewId: event.detail.reviewId,
            reviews$: reviews$,
        });
    };
</script>

{#if $status$ === STATUS.LOADING}
    <div class="gw-crv-reviews-list">
        {#each reviewSkeletonItems as key (key)}
            <ReviewsItemSkeleton />
        {/each}
    </div>
{/if}

{#if $status$ === STATUS.READY}
    <div class="gw-crv-reviews-list">
        {#each $reviews$ as review}
            <ReviewsItem
                {productQuery}
                {review}
                {wishlistProductStatusesQuery}
                {wishlistsService}
                on:openModal={handleOpenReviewModal}
            />
        {/each}
    </div>
{/if}

<style lang="postcss">
    .gw-crv-reviews-list {
        display: grid;
        align-items: start;
        grid-template-columns: repeat(4, 1fr);
        column-gap: 30px;
        row-gap: 110px;
    }
    @media all and (max-width: 600px) {
        .gw-crv-reviews-list {
            grid-template-columns: repeat(2, 1fr);
            column-gap: 20px;
            row-gap: 44px;
            margin-top: 38px;
        }
    }
</style>
